<script>
  import { gsap } from "gsap"
  import { createEventDispatcher } from "svelte"
  import { _, json } from "svelte-i18n"

  const dispatch = createEventDispatcher()
  // import { onMount } from "svelte"

  import { state, config, mode, sounds, praxi } from "../js/stores.js"
  import { getRandInt, changeMessage } from "../js/functions"
  import {
    animBubbles,
    moveBubble,
    animCell,
    moveSelectedBubblesBack,
    bubblesToFuel,
    fadeOutTargets,
  } from "../js/animations.js"

  let check = $mode === "easy" ? 0 : 1
  $: {
    if ($state.selectedNums > check) checkSolution()
  }

  function playHoverSound() {
    $sounds.hover.currentTime = 0
    $sounds.hover.play()
  }

  function checkSolution() {
    let result = $praxi === "prosthesi" ? 0 : 1

    let nums = document.querySelectorAll(".selected")
    for (let i = 0; i < nums.length; i++) {
      if ($praxi === "prosthesi") {
        result += nums[i].innerHTML * 1
      } else {
        result *= nums[i].innerHTML * 1
      }
    }

    if ($state.targetNum === result) {
      // console.log("Συγχαρητήρια!")
      // dispatch("newMessage")
      $sounds.correct.play()

      changeMessage(
        $json("congrats")[getRandInt(0, $json("congrats").length - 1)]
      )
      $state.scorePositive += $config.positiveAnswer

      gsap
        .timeline({
          onComplete: () => {
            if ($state.currentCell === 4) $state.rocketFull = true
            if ($state.currentCell < 4) $state.currentCell++
            $state.selectedNums = 0
            // dispatch event to be handled in App.svelte
            // We should generate new numbers and reset the positions of the bubbles
            dispatch("correct")
          },
        })
        .add(bubblesToFuel(), "start")
        .add(animCell(), "start+=0.2")
        .add(animBubbles("hide"), "start+=1")
        .add(fadeOutTargets(), "start+=1")
    } else {
      $sounds.wrong2.play()
      // $sounds.wrong1.play()
      changeMessage(
        $_($praxi === "prosthesi" ? "moreHelpMsg" : "helpMsg"),
        false
      )
      $state.scoreNegative += $config.negativeAnswer
      moveSelectedBubblesBack()
    }
  }
</script>

{#each $state.numbers as num, i}
  <div
    class="bubble"
    id="bubble{i + 1}"
    on:click={moveBubble}
    on:mouseover={playHoverSound}
  >
    {num}
  </div>
{/each}

<!-- <div class="bubble" id="bubble1" on:click={moveBubble}>5</div>
<div class="bubble" id="bubble2" on:click={moveBubble}>9</div>
<div class="bubble" id="bubble3" on:click={moveBubble}>14</div>
<div class="bubble" id="bubble4" on:click={moveBubble}>31</div> -->

<!-- <div class="bubble" id="bubble5" on:click={moveBubble}>14</div> -->
<style>
  .bubble {
    width: 80px;
    height: 80px;
    /* background: #fff; */
    margin: 10px;
    /* opacity: 0.85; */
    font-size: 42px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    position: relative;
    cursor: pointer;
    color: white;

    box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2),
      inset 0px 30px 50px 5px rgb(61, 223, 223);

    opacity: 0;
  }

  @media (hover: hover) {
    .bubble:hover {
      /* box-shadow: 0px 0px 5px #fff; */
      box-shadow: 0 0 30px #fff, inset 0px 30px 50px 5px rgb(61, 223, 223);
    }
  }

  /* .bubble:not(.selected) {
    border: 1px solid red;
  } */

  @media (max-width: 600px) {
    .bubble {
      font-size: 26px;
      min-width: 50px;
      min-height: 50px;
      width: 50px;
      height: 50px;
      margin: 4px;
    }
  }

  @media (max-width: 350px) {
    .bubble {
      font-size: 22px;
      min-width: 40px;
      min-height: 40px;
      width: 40px;
      height: 40px;
      margin: 4px;
    }
  }
  /*
  @media (max-width: 460px) {
    .bubble {
      font-size: 20px;
      min-width: 40px;
      min-height: 40px;
      width: 40px;
      height: 40px;
      margin: 4px;
    }
  } */

  @media (max-height: 800px) and (min-width: 600px) {
    .bubble {
      font-size: 32px;
      min-width: 68px;
      min-height: 68px;
      width: 68px;
      height: 68px;
      margin: 4px;
    }
  }
</style>
